"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
//import 'font-awesome/css/font-awesome.css';
//import 'jquery-ajax-unobtrusive';
//import 'animate.css/animate.css';
//import 'sweetalert2/dist/sweetalert2.css';
require("./validation");
require("./theme.js");
//import * as $ from 'jquery';
const jquery_1 = __importDefault(require("jquery"));
require("bootstrap/dist/js/bootstrap.bundle.js");
require("../scss/site.scss");
require("bootstrap/scss/bootstrap.scss");
require("simple-line-icons/css/simple-line-icons.css");
require("bootstrap-select/dist/css/bootstrap-select.css");
require("@yaireo/tagify/dist/tagify.css");
class Common {
    constructor() {
        this.initExtensions();
        this.initPlugins();
    }
    initPlugins() {
        //var slider = new Flickity('.flickity', { wrapAround: true });
        (0, jquery_1.default)(function () {
            (0, jquery_1.default)('[data-toggle="tooltip"]').tooltip();
        });
    }
    initExtensions() {
        jquery_1.default.fn.serializeObject = function () {
            var arrayData, objectData;
            arrayData = this.serializeArray();
            objectData = {};
            jquery_1.default.each(arrayData, function () {
                var value;
                if (this.value != null) {
                    value = this.value;
                }
                else {
                    value = '';
                }
                if (objectData[this.name] != null) {
                    if (!objectData[this.name].push) {
                        objectData[this.name] = [objectData[this.name]];
                    }
                    objectData[this.name].push(value);
                }
                else {
                    objectData[this.name] = value;
                }
            });
            return objectData;
        };
    }
}
exports.Common = Common;
let common = new Common();
